/**
 * Entry point: loads global SCSS and the main app.
 *
 * Global SCSS must live on this entry (not only inside the lazy-loaded app chunk) so
 * HtmlWebpackPlugin + mini-css-extract emit <link> tags for the main bundle; otherwise
 * production HTML has no site CSS (map layout breaks, Flourish embeds are not hidden).
 */
import '../scss/styles.scss';
// PORTRAIT_NUDGE_REENABLE: import './portraitNudge.js';

import(/* webpackChunkName: "app" */ './initialization.js');

/* Desktop-only gate: load app only when viewport >= 1025px (disabled)
const DESKTOP_MIN_PX = 1025;
const desktopMq = window.matchMedia(`(min-width: ${DESKTOP_MIN_PX}px)`);

let appLoadStarted = false;

function loadApp() {
    if (appLoadStarted) return;
    appLoadStarted = true;
    import('./initialization.js');
}

function onDesktopMqChange() {
    if (desktopMq.matches) loadApp();
}

if (desktopMq.matches) {
    loadApp();
} else if (typeof desktopMq.addEventListener === 'function') {
    desktopMq.addEventListener('change', onDesktopMqChange);
} else {
    desktopMq.addListener(onDesktopMqChange);
}
*/
